export default "__VITE_ASSET__K$xuYhB0__"